import styled from '../../../../styles/theme';
import { ModalTiresDetailStyled } from '../ModalTiresDetailStyled';
import { rem } from 'polished';

export const ModalTiresDetailStyledAP = styled(ModalTiresDetailStyled)`
    a {
        color: ${({ theme }) => theme.colors.primary};
        
        &:hover {
            color: ${({ theme }) => theme.colors.black};
            
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
        
        svg {
            width: ${rem(20)};
            height: ${rem(12)};
            
            path {
                fill: ${({ theme }) => theme.colors.primary};
            }
        }
    }
`;
